export const homeConstants = {
  GETALL_REQUEST: "HOME_GETALL_REQUEST",
  GETALL_SUCCESS: "HOME_GETALL_SUCCESS",
  GETALL_FAILURE: "HOME_GETALL_FAILURE",

  GET_FILES_BUCKETS_STATES_SUCCESS: "HOME_GET_FILES_BUCKETS_STATES_SUCCESS",
  GET_24H_FILE_SAMMARY_SUCCESS: "HOME_GET_24H_FILE_SAMMARY_SUCCESS",
  GET_7D_FILE_SAMMARY_SUCCESS: "HOME_GET_7D_FILE_SAMMARY_SUCCESS",
  GET_LAST_5_INCOMING_FILES_SUCCESS: "HOME_GET_LAST_5_INCOMING_FILES_SUCCESS",

  GET_FILES_REQUEST: "HOME_GET_FILES_REQUEST",
  GET_FILES_SUCCESS: "HOME_GET_FILES_SUCCESS",
  GET_FILES_FAILURE: "HOME_GET_FILES_FAILURE",

  GET_DOCS_REQUEST: "HOME_GET_DOCS_REQUEST",
  GET_DOCS_BY_RECEIVER_REQUEST: "HOME_GET_DOCS_BY_RECEIVER_REQUEST",
  GET_DOCS_EBID_REQUEST: "HOME_GET_DOCS_EBID_REQUEST",
  GET_DOCS_SUCCESS: "HOME_GET_DOCS_SUCCESS",
  GET_DOCS_BY_RECEIVER_SUCCESS: "HOME_GET_DOCS_BY_RECEIVER_SUCCESS",
  GET_DOCS_EBID_SUCCESS: "HOME_GET_DOCS_EBID_SUCCESS",
  GET_DOCS_FAILURE: "HOME_GET_DOCS_FAILURE",

  CLEAR_FILTERS: "HOME_CLEAR_FILTERS"
};
